import React from "react"

const Navbar = () => (
  <footer>
    <p>Made with &lt;3  and green tea </p>
  </footer>
)

export default Navbar
